import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class SalesChannel extends BaseEntity{
    
    salesChannelCode : string;
    name : string;
    rank : number;
    iconCode : string;
    colorname : string;
    alpha : number;
    penCode : string;
    whenSelectedIconCode : string;
    timing : number;

}
